const Locales = ["en", "fr"];

/** *
 * @param {string} url
 * @param {string?} locale
 * @param {boolean?} insert
 * @returns {string}
 * @description
 * Returns the URL with first instance of possible locale parameters replaced with the current locale.
 * If none of the possible locale parameters are found, returns the URL unchanged.
 * If @insert is true, the current locale is inserted at the beginning of the URL.
 */
export const updateURLLocale = (
  url: string,
  locale?: string,
  insert?: boolean
): string => {
  if (!locale) {
    return url;
  }
  for (let i = 0; i < Locales.length; i += 1) {
    const localeCode = Locales[i];
    if (url.includes(`/${localeCode}/`)) {
      return url.replace(`/${localeCode}/`, `/${locale}/`);
    }
  }
  if (insert) {
    try {
      const objURL = new URL(url);
      return `${objURL.origin}/${locale}${objURL.pathname}${objURL.search}`;
    } catch (_) {
      return `/${locale}${url}`;
    }
  }
  return url;
};

export default updateURLLocale;
